"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _formik = require("formik");

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _excluded = ["field", "form", "label", "options"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SelectFormField = function SelectFormField(_ref) {
  var field = _ref.field,
      form = _ref.form,
      label = _ref.label,
      options = _ref.options,
      props = _objectWithoutProperties(_ref, _excluded);

  var errorText = (0, _formik.getIn)(form.touched, field.name) && (0, _formik.getIn)(form.errors, field.name);
  return /*#__PURE__*/_react["default"].createElement(_core.FormControl, {
    fullWidth: true,
    error: !!errorText
  }, label && /*#__PURE__*/_react["default"].createElement(_core.InputLabel, null, label), /*#__PURE__*/_react["default"].createElement(_core.Select, _extends({
    fullWidth: true
  }, field, props), options.map(function (op) {
    return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      key: op.value,
      value: op.value
    }, op.label);
  })), /*#__PURE__*/_react["default"].createElement(_core.FormHelperText, null, errorText));
};

var _default = SelectFormField;
exports["default"] = _default;